import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faHourglass } from '@fortawesome/free-solid-svg-icons';
import { checkUserUrl } from '../Utils/Utils';
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import Axios from '../../axios/Axios';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const AdminBillingTransactionHistory = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;

    const {id, username} = useParams();
    const [paymentTransactionList, setPaymentTransactionList] = useState(null);
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [bgColor, setBgColor] = useState("alert alert-success alert-dismissible");

    useEffect(() => {
        fetchData();
    }, [userId, userToken]);

    const fetchData = async () => {
        try {
            let paramData = {
                user_id: userId,
                token: userToken,
                retr_user_id: id,
                method: "fetch_transaction"
            }
            let {data} = await Axios.post(`${NODE_HOST_URL_v1}/Transaction`,paramData)
            if (data.success === true) {
                setPaymentTransactionList(data);
            } else {
                setSuccessMessage(true);
                setBgColor("alert alert-danger alert-dismissible");
                setErrorMessage(data.message);
            }
        } catch (error) {
            console.error('Error fetching transaction history:', error);
            setSuccessMessage(true);
            setBgColor("alert alert-danger alert-dismissible");
            setErrorMessage("Something went wrong. Please try again later.");
        }
    };

    return (
        <div>
            <AdminLayout>
                <Title isButton={false}> Billing Report </Title>
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3><strong> Last Transaction </strong> Details of <strong>{username}</strong></h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card">
                                <div className="card-body">
                                    {successMessage && (
                                        <div className={bgColor} role="alert">
                                            {errorMessage}
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="col-12 col-lg-12 col-xxl-12">
                                            <div className="col-12">
                                                {paymentTransactionList ? (
                                                    <div className="table-responsive" style={{ overflowX: "auto" }}>
                                                        <table className="table table-striped table-xs table-sm my-0">
                                                            <thead>
                                                                <tr>
                                                                    <th className="d-xl-table-cell">Amount</th>
                                                                    <th className="d-xl-table-cell">Status</th>
                                                                    <th>Transaction ID</th>
                                                                    <th>Description</th>
                                                                    <th>Remark</th>
                                                                    <th className="d-md-table-cell">Date / Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {paymentTransactionList.data.map((item, i) => (
                                                                    <tr key={i}>
                                                                        <td style={{ color: item.amount < 0 ? "red" : "green" }}>{item.amount}</td>
                                                                        <td>
                                                                            {item.status === 1 ? (
                                                                                <span className="badge bg-success">
                                                                                    <FontAwesomeIcon icon={faCheckCircle} color='#fff' /> Success
                                                                                </span>
                                                                            ) : item.status === 0 ? (
                                                                                <span className="badge bg-info">
                                                                                    <FontAwesomeIcon icon={faHourglass} color='#fff' /> Pending
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge bg-danger">
                                                                                    <FontAwesomeIcon icon={faTimesCircle} color='#fff' /> Failed
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td style={{ color: item.amount < 0 ? "red" : "green" }}>{item.transaction_id}</td>
                                                                        <td style={{ color: item.amount < 0 ? "red" : "green" }}>{item.description}</td>
                                                                        <td style={{ color: item.amount < 0 ? "red" : "green" }}>{item.remark}</td>
                                                                        <td style={{ color: item.amount < 0 ? "red" : "green" }}>{item.created}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="text-center">
                                                        <div className="card-body">
                                                            <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                            <p>NO transaction Details Found</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </AdminLayout>
        </div>
    );
};

export default AdminBillingTransactionHistory;
